export default {
  global: {
    send: 'Senden',
    save: 'Speichern',
    confirm: 'Bestätigen',
    cancel: 'Abbrechen',
    brand: 'HeiGIT - Universität Heidelberg',
    close: 'Schließen',
    closeAndDoNotShowAgain: 'Close and do not show it again',
    select: 'Auswählen',
    yes: 'Ja',
    no: 'Nein',
    and: 'und',
    noAndDonAskAgain: 'Nein (nicht mehr fragen)',
    ok: 'Ok',
    polygon: 'Polygon',
    developedByIntro: 'Services entwickelt von',
    developedBy: 'HeiGIT gGmbH',
    duration: 'Dauer',
    distance: 'Entfernung',
    elevation: 'Höhe',
    profile: 'Profil',
    options: 'Optionen',
    parameters: 'Parameter',
    custom: 'Benutzerdefiniert',
    customOverlayer: 'Benutzerdefinierte Überschicht',
    rawRouting: 'Rohes Routing',
    months: {
      january: 'Januar',
      february: 'Februar',
      march: 'März',
      april: 'April',
      may: 'Mai',
      june: 'Juni',
      july: 'Juli',
      august: 'August',
      september: 'September',
      october: 'Oktober',
      november: 'November',
      december: 'Dezember'
    },
    monthsShort: {
      january: 'Jan',
      february: 'Feb',
      march: 'Mär',
      april: 'Apr',
      may: 'Mai',
      june: 'Jun',
      july: 'Jul',
      august: 'Aug',
      september: 'Sep',
      october: 'Okt',
      november: 'Nov',
      december: 'Dez'
    },
    units: {
      km: 'km',
      mi: 'M',
      m: 'm',
      meters: 'Meter',
      seconds: 'Sekunden',
      s: 's',
      minutes: 'Minuten',
      min: 'min',
      hours: 'h',
      days: 't',
      lat: 'Breite',
      lng: 'Länge',
      tones: 'Töne',
      t: 't',
      kmh: 'km/h'
    },
    layers: {
      macrocounty: 'Macro county',
      country: 'Land',
      region: 'Region',
      county: 'Bezirk',
      macroregion: 'Makroregion',
      neighbourhood: 'Nachbarschaft',
      locality: 'Lokalität',
      borough: 'Bezirk',
      localadmin: 'Lokaler Administrator',
      address: 'Adresse',
      street: 'Straße',
      venue: 'Tagungsort',
      rawCoordinate: 'Long,Lat Koordinaten',
      notAvailable: 'Nicht verfügbar',
      postalcode: 'Postleitzahl',
      'undefined': 'Nicht definiert',
      ocean: 'Ozean'
    },
    population: 'Einwohner',
    green: 'Grün',
    noise: 'Lärm',
    steepness: 'Steilheit',
    surface: 'Oberfläche',
    roadaccessrestrictions: 'Straßen Zugangsbeschränkung',
    waytype: 'Weg Art',
    suitability: 'Eignung',
    waycategory: 'Wegkategorie',
    tollways: 'Mautstraßen',
    traildifficulty: 'Trail Schwierigkeit',
    osmid: 'OSM ID',
    countryinfo: 'Länderinfo',
    csv: 'Hitzestress' // HEAL api
  }
}
